import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const ArrowRightIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24 11.9975C24.0006 12.1263 23.9518 12.2554 23.8535 12.3537L14.3528 21.8537C14.1576 22.0489 13.8412 22.0487 13.6462 21.8534C13.4512 21.6581 13.4513 21.3415 13.6465 21.1463L22.3138 12.4797L22.1776 12.4898H0.5C0.223858 12.4898 0 12.2705 0 12C0 11.7295 0.223858 11.5102 0.5 11.5102H22.2356L22.3098 11.5163L13.6465 2.8537C13.4513 2.65852 13.4512 2.34194 13.6462 2.1466C13.8412 1.95125 14.1576 1.95112 14.3528 2.1463L23.8535 11.6463C23.9505 11.7433 23.9994 11.8703 24 11.9975Z'
      />
    </svg>
  );
};
